import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/modules/auth/ProtectedRoute';
import PlaceholderPage from '@/modules/common/components/PlaceholderPage';
import CobranzaPage from '@/modules/finance/components/CobranzaPage';
import RevenuePage from '@/modules/finance/components/RevenuePage';
import ReportesPage from '@/modules/finance/components/ReportesPage';
import LlmCostDashboard from '@/modules/finance/components/costs/LlmCostDashboard';

export const financeRoutes = [
  <Route key="/contabilidad/cobranza" path="/contabilidad/cobranza" element={
    <ProtectedRoute requiredPermission="finance.accounting.view">
      <CobranzaPage />
    </ProtectedRoute>
  } />,
  <Route key="/contabilidad/facturacion" path="/contabilidad/facturacion" element={
    <ProtectedRoute requiredPermission="finance.accounting.view">
      <PlaceholderPage title="Facturación" description="Emisión y control de facturas — Integración Facturama (próximamente)" />
    </ProtectedRoute>
  } />,
  <Route key="/contabilidad/presupuesto" path="/contabilidad/presupuesto" element={
    <ProtectedRoute requiredPermission="finance.accounting.view">
      <PlaceholderPage title="Presupuesto" description="Planificación y control presupuestal" />
    </ProtectedRoute>
  } />,
  <Route key="/contabilidad/revenue" path="/contabilidad/revenue" element={
    <ProtectedRoute requiredPermission="finance.accounting.view">
      <RevenuePage />
    </ProtectedRoute>
  } />,
  <Route key="/contabilidad/costos-ia" path="/contabilidad/costos-ia" element={
    <ProtectedRoute requiredPermission="finance.accounting.view">
      <LlmCostDashboard />
    </ProtectedRoute>
  } />,
  <Route key="/contabilidad/reportes" path="/contabilidad/reportes" element={
    <ProtectedRoute requiredPermission="finance.accounting.view">
      <ReportesPage />
    </ProtectedRoute>
  } />,
];
